import React, { useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Grid } from '@mui/material';
import WebListing_GridCard from '@Components/Listings/WebListing_GridCard';
import WebListing_MobileCard from '@Components/Listings/WebListing_MobileCard';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import { loadable } from '@Components/Utilities/SandhillsLoadable';




const WizardResults = ({ props, results, selectedAnswers }) => {

    const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

    const [isSaved, setIsSaved] = useState(false);
    const windowSize = useWindowSize();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [feedbackModalSubjectDropDown, setFeedbackModalSubjectDropDown] = useState(props.SubjectDropDown);
    const toggleFeedbackModal = () => setShowFeedbackModal(!showFeedbackModal);

    const towAnswer = selectedAnswers.find(answer => answer.QuestionKey == "tow-rv")
    const experienceAnswer = selectedAnswers.find(answer => answer.QuestionKey == "rv-experience")


    const getListingCardProps = (listing, index) => ({
        ...listing,
        Id: listing.ListingId,
        DealerGroupID: listing.SendAMessageRetailGroupID || 0,
        LazyLoad: index > (windowSize.width >= 700 && windowSize.width < 1000 ? 2 : windowSize.isMobile ? 1 : 4),
        ForceLoadImages: listing.ForceLoadImages || index < (windowSize.width >= 700 && windowSize.width < 1000 ? 2 : windowSize.isMobile ? 1 : 4),
        AriaLabelTitle: listing.ListingTitle + " (" + (index + 1) + ")",
        IsRecommendedListingsSearch: true,
        IsSimilar: false,
        ImageUrl: listing.ImageUrl || [],
        UserWatchlist: listing.UserWatchlist || [],
        ListingTypes: listing.ListingTypes || [],
        Specs: listing.Specs || [],
        BestForTags: listing.BestForTags || [],
        IsSearchEngine: false,
        ShowEmployeeOnlyInfo: false,
        IsWatchList: false,
        IsWatchlistMyBids: false,
        ListPageDescriptionMaxLength: 500,
        ListPageSpecMaxLength: 6,
        openFinancialCalculator: () => { },
        WatchlistURL: '',
        SetBuyersPremiumData: () => { },
        WatchlistTitle: '',
        WatchlistClickDelete: () => { },
        openEmailModal: () => { },
        HasFormAssembly: false,
        IsCompareChkBoxDisabled: true,
        UpdateCompareListing: () => { },
        IsCheckedForCompare: false,
        ShowCompareURL: false,
        ShippingEstimateImageUrl: '',
        CompareUrl: '',
        UseDataProperties: false,
        LocationString: '',
        PricingInfo: {},
        DispatchListings: () => { },
        resetAuctionData: () => { },
        sortApplied: '',
        LoginLink: '',
        CustomWatchlists: [],
        CustomWatchListLinks: [],
        getUserWatchlist: () => { },
        addToWatchlistCount: () => { },
        IsEventPage: false,
        notificationSettings: {},
        RequestAQuote: false,
        IsRY: false,
        ShowAuctionBranding: false,
        ShowPreAuctionTime: false,
        IsFTISearch: false,
        setCountdownListings: () => { },
        PhoneClickToTrackURL: '',
        Widgets: {
            ShowMonthlyFinanceRatesOnListings: false,
            ShowLenderWidget: false,
        },
        IsWizardPage: true,
        openDetailPageInNewTab: false,
        IsMobileCard: windowSize?.isMobile,
    });

    return (
        <div className='wizard-results'>
     
            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={translator.translate("sandhills.tradesites.mvc.rvbuyingguide").toUpperCase()} />
            {results.RecommendedCategory && (
                <div className='section'>
                    <div className="category-section">
                        <div className="category-text">
                            <h1>{translator.translate("sandhills.tradesites.mvc.heresyourperfectrvsetup")}</h1>
                            <p>{translator.translate("sandhills.tradesites.mvc.basedonanswershereswhatwerecommend")}</p>
                            <div className="recommended">
                                <h2>{translator.translate("sandhills.tradesites.mvc.primarymatch").replace("{0}", results.RecommendedCategory.PrimaryCategoryName)}</h2>
                                {results.RecommendedCategory.SecondaryCategoryId > 0 && <p className="secondary-category">{translator.translate("sandhills.tradesites.mvc.alsoconsider").replace("{0}", results.RecommendedCategory.SecondaryCategoryName)}</p>}
                            </div>
                            <p>{results.RecommendedCategory.PrimaryCategoryCaption}</p>
                            <div className="category-buttons">
                                <a className="ts-button" href={results.ViewAllUrl}>{translator.translate("sandhills.tradesites.mvc.findavaliablervsthatmatchyoursetup")}</a>
                                <a className="ts-button" onClick={toggleFeedbackModal}>{translator.translate("sandhills.haveaquestion")}</a>
                            </div>
                        </div>
                        <div className="img-container">
                            <img src={results.RecommendedCategory.ImageUrl} alt={results.RecommendedCategory.PrimaryCategoryName} />
                        </div>
                        {showFeedbackModal &&
                            <FeedbackModal
                                {...props}
                                toggleModal={toggleFeedbackModal}
                                title={feedbackModalSubjectDropDown[0].Text}
                                SubjectDropDown={feedbackModalSubjectDropDown}
                            />}
                    </div>
                </div>
            
            )}

            {towAnswer.AnswerKey &&
                <div className="section">
                    <div className="tow-section">
                        <h2>{translator.translate("sandhills.tradesites.mvc.doyouplantotowyourrv")}</h2>
                        <p className="tow-answer">{towAnswer.AnswerText}</p>
                        <div dangerouslySetInnerHTML={{ __html: towAnswer.AnswerCaption }} />
                    </div>
                </div>
            }

            {results.TopMakeModels && results.TopMakeModels.length > 0 && (
                <div className='section'>
                    <div className="tow-section">
                        <h2>{translator.translate("sandhills.tradesites.mvc.topmodelsforyou")}</h2>
                        <p className="tow-answer">{experienceAnswer.AnswerText}</p>
                        <p>{experienceAnswer.AnswerCaption}</p>
                        <div className="manu-container">
                            {results.TopMakeModels.map((model, index) => (
                                <div className="manu-list" key={index}>
                                    <h3>{model.Manufacturer} {model.Model}</h3>
                                    <div className="top-section">
                                        {(model.MinWeight > 0) && <><strong>{translator.translate("sandhills.tradesites.mvc.dryweight").replace("{0}", model.MinWeight == model.MaxWeight ? `${model.MinWeight} lbs` : `${model.MinWeight} - ${model.MaxWeight} lbs`)}</strong><br/></>}
                                        {(model.MinSleeps > 0) && <><strong>{translator.translate("sandhills.tradesites.mvc.sleeps").replace("{0}", model.MinSleeps == model.MaxSleeps ? model.MinSleeps : `${model.MinSleeps} - ${model.MaxSleeps}`)}</strong></>}
                                    </div>
                                    <div>
                                        <strong>{translator.translate("sandhills.tradesites.mvc.bestfor")}</strong>
                                        <ul>
                                            {model.BestForTagStates.map((tag, index) => (
                                                <li key={index}>
                                                    {tag.IsMatch ?
                                                        <i className="fa-regular fa-circle-check"></i>
                                                        :
                                                        <i className="fa-regular fa-circle-xmark"></i>
                                                    }
                                                    {tag.Label}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <a href={model.Url} className='ts-button'>{translator.translate("sandhills.search")}</a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {results?.Listings?.length > 0 && (
                <div className='section no-border'>
                    <h2>{translator.translate("sandhills.tradesites.mvc.availablervsthatmatchyoursetup")}</h2>
                    <div className="list-container-flexrow">
                        {results.Listings.map((listing, index) => (
                            <div className="list-listing-card-wrapper" key={index}>
                                {!windowSize?.isMobile ?
                                    <WebListing_GridCard {...getListingCardProps(listing, index)} />
                                    :
                                    <WebListing_MobileCard {...getListingCardProps(listing, index)} />
                                }
                            </div>
                        ))}
                    </div>
                    <div className="button-container">
                        <a className="ts-button" href={results.ViewAllUrl}>{translator.translate("sandhills.tradesites.mvc.viewmoreresults")}</a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WizardResults;
global.WizardResults = WizardResults;